import { __extends } from "tslib";
import { Sprite } from './Sprite';
import { TesselatedFontTable } from '../text/TesselatedFontTable';
import { HierarchicalProperty } from '@awayjs/view';
/**
 * TextSprite is used for masked text.
 * It is a child of the textfield that is used to render all visible (masked) graphics
 */
var TextSprite = /** @class */ (function (_super) {
    __extends(TextSprite, _super);
    function TextSprite() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextSprite.prototype._acceptTraverser = function (traverser) {
        var tf = this.parentTextField;
        //tf.reConstruct(true);
        if (tf._textFormat && !tf._textFormat.font_table.isAsset(TesselatedFontTable) && !tf._textFormat.material) {
            this.transform.colorTransform.color = (tf.textColor != null) ? tf.textColor : tf._textFormat.color;
            this._invalidateHierarchicalProperty(HierarchicalProperty.COLOR_TRANSFORM);
        }
        this._graphics._acceptTraverser(traverser);
    };
    return TextSprite;
}(Sprite));
export { TextSprite };
